import React, { useState, useEffect } from "react";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { LabelBox } from "../../TempAccount/TempAccount/TempAccountModal/RentPartySection/RentPartyList";
import { Input } from "../../../../Input/Input";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";

interface UpdatePgModalProps extends DefaultModalCommonProps {
  data: { id: number; servName: string; orderNum: number }[];
}

export default function UpdatePgModal({
  closeEvent,
  data,
  confirmEvent,
}: UpdatePgModalProps) {
  const [updatePg, setUpdatePg] = useState(false);
  const [list, setList] = useState<{ id: number; orderNum: number }[]>([]);
  const [order, setOrder] = useState<{ [key: number]: string }>({
    0: "",
  });

  const { response, loading, error } = useApi({
    method: "post",
    url: updatePg ? `version/billorder` : undefined,
    data: {
      list,
    },
  });

  console.log(order);

  useEffect(() => {
    if (data?.length > 0) {
      let init: { [key: number]: string } = {};

      data?.forEach((d) => {
        init[d?.id] = "";
      });

      setOrder(init);
    }
  }, [data]);

  useEffect(() => {
    const result = Object.keys(order).map((key) => {
      console.log(key);

      return {
        id: +key,
        orderNum: +order[+key],
      };
    });

    setList(result);
  }, [order]);

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("결제 PG사를 업데이트 하였습니다.");

      if (confirmEvent) confirmEvent();
      closeEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "결제 PG사 우선순위를 업데이트 하는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="결제 PG사 관리"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setUpdatePg(true)}
        isMediumModal={true}
        confirmDisabled={Object.values(order)?.includes("")}
      >
        <ModalLabel>우선순위 관리</ModalLabel>

        <>
          {data?.map((d) => (
            <ModalRow
              key={d.id}
              style={{ justifyContent: "space-between", gap: 10 }}
            >
              <LabelBox
                style={{
                  width: "30%",
                  color: "#808080",
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {d?.servName}
              </LabelBox>

              <Input
                type="number"
                inputMode="numeric"
                placeholder="숫자를 입력해 주세요."
                value={order[d?.id]!}
                onChange={(e) =>
                  setOrder((prev) => ({
                    ...prev,
                    [d?.id]: e.target.value,
                  }))
                }
              />
            </ModalRow>
          ))}
        </>
      </DefaultModalLayout>

      {loading && <Loader />}
    </>
  );
}
